import type { ApiUser } from "@/lib/api/client";
import { cn } from "@/lib/utils";

const AVATAR_COUNT = 24;

/** Stable avatar (1..24) per user, so everyone keeps the same character across devices. */
export function avatarSrc(user: Pick<ApiUser, "id" | "email"> | null): string {
  const key = user?.id || user?.email || "guest";
  let hash = 2166136261;
  for (let i = 0; i < key.length; i++) hash = Math.imul(hash ^ key.charCodeAt(i), 16777619);
  const n = ((hash >>> 0) % AVATAR_COUNT) + 1;
  return `/avatars/avatar-${String(n).padStart(2, "0")}.png`;
}

/** Illustrated profile avatar. Decorative by default; the surrounding link/label names the user. */
export function UserAvatar({ user, size = 32, className }: { user: Pick<ApiUser, "id" | "email"> | null; size?: number; className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- tiny static PNG, no optimisation needed
    <img src={avatarSrc(user)} alt="" width={size} height={size} draggable={false} className={cn("block shrink-0 rounded-full", className)} style={{ width: size, height: size }} />
  );
}
